import React from 'react';
import { PendingModal, PendingModalProps } from '@common-fe/common-fe';

import useAutoBlockedModal from './hooks/useAutoBlockedModal';

const PendingBlockedModal: React.FC<PendingModalProps> = (props) => {
  const { isClosingByClickOutsideBlocked } = useAutoBlockedModal({ visible: props?.visible });

  return (
    <PendingModal
      {...props}
      isClosingByClickOutsideBlocked={isClosingByClickOutsideBlocked || props?.isClosingByClickOutsideBlocked}
    />
  );
};

export default PendingBlockedModal;
